<template>
  <section>
    <!-- Si tengo id de materia, puedo editar sus módulos -->
    <div v-if="materia">
      <b-list-group
        ref="group"
        :style="{height: trHeight}"
        class="repeater-form"
        @submit.prevent="repeateAgain"
      >
        <b-list-group-item
          v-for="(item, index) in modulosProp"
          :id="item.id"
          :key="item.id"
          ref="item"
          class="flex-column align-items-start"
        >
          <!-- Acciones sobre módulo -->
          <div class="text-right mt-1 mb-1">
            <!-- Editar / Guardar -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              size="sm"
              class="mr-75"
              @click="(item.id) ? doSomethingToModule({ action: 7, modulo: item.id, datos: JSON.stringify(item) }) : doSomethingToModule({ action: 6, materia: materia, datos: JSON.stringify(item) })"
            >
              <feather-icon
                :icon="(item.id) ? 'ToolIcon' : 'PlusIcon'"
                class="mr-50"
              />
              <span class="align-middle">{{ (item.id) ? 'Editar' : 'Guardar nuevo' }}</span>
            </b-button>

            <!-- Remover de nuevo módulo o eliminar módulo -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              size="sm"
              @click="(item.id) ? deleteModule(item) : removeItem(index)"
            >
              <feather-icon :icon="(item.id) ? 'Trash2Icon' : 'XIcon'" />
            </b-button>
          </div>
          <!-- Título y orden de módulo -->
          <b-row>
            <!-- Título de módulo -->
            <b-col
              md="9"
              class="mb-1"
            >
              <label :for="`modulo-titulo${index}`">Título</label>
              <b-form-input
                :id="`modulo-titulo${index}`"
                v-model="modulosProp[index].titulo"
                type="text"
                placeholder="Título"
                size="sm"
              />
            </b-col>
            <!-- Orden del módulo -->
            <b-col
              md="3"
              class="mb-1"
            >
              <label :for="`modulo-orden${index}`">Orden</label>
              <b-form-spinbutton
                :id="`modulo-orden${index}`"
                v-model="modulosProp[index].orden"
                min="1"
                max="100"
                size="sm"
              />
            </b-col>
          </b-row>

          <!-- Descripción del módulo -->
          <div>
            <label for="modulo-titulo">Descripción</label>
            <b-form-textarea
              id="modulo-descripcion"
              v-model="modulosProp[index].descripcion"
              placeholder="Descripción"
              rows="5"
              size="sm"
              no-resize
            />
          </div>
        </b-list-group-item>
      </b-list-group>

      <!-- Crear nuevo módulo -->
      <div class="text-center mt-1">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="repeateAgain"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Nuevo módulo</span>
        </b-button>
      </div>
    </div>
    <!-- Si no tengo id de materia, muestro mensaje -->
    <div v-else>
      <b-alert
        variant="danger"
        show
      >
        <div class="alert-body">
          Para poder agregar módulos a la materia, <b>es necesario haberla dado de alta</b>, para ello guarde la información de la pestaña <b>"Principal"</b>, posteriormente, búsque la asignatura en el listado general y <b>modifique sus módulos</b>
        </div>
      </b-alert>
    </div>
  </section>
</template>

<script>
import {
  BFormInput,
  BRow,
  BCol,
  BButton,
  BListGroup,
  BListGroupItem,
  BFormTextarea,
  BFormSpinbutton,
  BAlert,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BFormTextarea,
    BFormSpinbutton,
    BAlert,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    materia: {
      type: Number,
      default: null,
    },
    modulosProp: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    modulosProp(modulos) {
      if (modulos.length === 0) this.initTrHeight()
    },
  },
  mounted() {
    if (this.materia) {
      this.initTrHeight()
      window.addEventListener('resize', this.initTrHeight)
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    doSomethingToModule(dataModule) {
      this.$emit('set-loader', true)
      // eslint-disable-next-line no-param-reassign
      dataModule.task = 'wsmaterias'

      this.$store.dispatch('servicioEscolar/postServicioEscolar', dataModule)
        .then(response => {
          this.$emit('set-loader', false)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          this.$emit('reload-data')
        }, error => {
          this.$emit('set-loader', false)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [CRUD Módulos]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    },
    deleteModule(module) {
      this.$swal({
        title: '¿Está seguro de eliminar?',
        html: `Si continúa se eliminará el módulo: <b>"${module.titulo}"</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.doSomethingToModule({ action: 8, modulo: module.id })
          this.trTrimHeight(this.$refs.item[0].offsetHeight)
        }
      })
    },
    repeateAgain() {
      const sizeArray = this.modulosProp.length
      const orden = (sizeArray === 0) ? 1 : this.modulosProp[sizeArray - 1].orden + 1
      this.modulosProp.push({ orden, titulo: '', descripcion: '' })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.item[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.modulosProp.splice(index, 1)
      this.trTrimHeight(this.$refs.item[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.group.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
